<template>
  <div class="page" v-wechat-title="$route.meta.title='金牌讲解员'">
    <div class="waterfall px-container clearfix">
      <ul v-if="newWaterfallData!=undefined" class="fl px-waterfall border-box" v-for="(el,ind) in newWaterfallData" :key="ind">
        <li class="border-box" v-for="(item,index) in el" :key="item.id" @click="toGuide(item.id)">
          <div class="clearfix" style="position: relative;">
            <div class="icon-tx clearfix" v-if="item.logo">
              <img :src="item.logo" :key="item.id" alt="" >
            </div>
            <div class="fl bottom-box border-box">
              <div class="bag-name" v-if="item.tag">{{item.tag}}</div>
              <div class="guide-name clearfix hide">
                <span class="fl name hide">{{item.name}}</span>
                <span class="fr num" v-if="item.score">评分{{item.score}}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="load-tip">
      <p>
        <span class="l"></span>
        <span class="m">{{loadText}}</span>
        <span class="r"></span>
      </p>
    </div>

    <img class="to-home" src="../../assets/to-home.png" @click="toHome" alt="">

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>
</template>

<script>
  import P400 from '../../components/P400'
  import {getScenicGuide} from "@/service/getData";
  import {wxGetPosition,wxShareme,  } from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        userInfo: {}, //用户信息
        scenicId: this.$route.query.scenicId || '', //景区id
        scenicKey: this.$route.query.scenicKey || '', //来源标记
        total: '',//导游总数
        searchTotal:'',//弹窗导游总数
        page: 1,
        pageSize: 10,
        loadText: "数据加载中",
        root:[],
        newWaterfallData: '',
        waterfallDataNumber:'',

        P400: 0, //系统维护中
      }
    },
    created() {
      this.$loading.show('数据加载中');
      this.getScenicGuideFun(this.page);

      window.addEventListener("scroll",this.handleFun)
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {
      //获取评论数据
      async getScenicGuideFun(page){
        let res = await getScenicGuide({
          pageNum: page,
          pageSize: this.pageSize,
          scenicId: this.scenicId,
      time: (new Date().getTime())
        });
        if (res.errcode === '00000') {
          this.$loading.hide();
          this.total = res.total;

          let root = res.data;
          if (page >= Math.ceil(this.total / this.pageSize) || root.length >= this.total) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
            let [ ...waterfallData ]  = this.root;
            let [ ...newWaterfallData ]= [[],[]];
            this.root.forEach((el,i) => {
              switch( i%2 ) {
            case 0 : newWaterfallData[0].push(el)
              break
            case 1: newWaterfallData[1].push(el)
              break
            }
          });
            this.newWaterfallData = [newWaterfallData[0],newWaterfallData[1]]
          } else {
            if (page == 1) {
              document.documentElement.scrollTop = document.body.scrollTop = 0;
              this.root = [];
              this.newWaterfallData = [[],[]];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }


        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.getScenicGuideFun(page);
          });
        })
      },

      //跳转到导游详情页面
      toGuide(id){
        this.$router.push({
          path: `/guide?${'id='+id+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
        });
      },

      //返回至首页
      toHome(){
        this.$router.replace({path: `/?scenicId=`+this.scenicId+'&scenicKey='+this.scenicKey });
      },
    },

    watch:  {
      searchShow(newVal,oldVal){
        if(newVal == 1 ){
          document.getElementById("scollBox").addEventListener("scroll",this.handleFun1)
        }else {
          document.getElementById("scollBox").removeEventListener("scroll",this.handleFun1)
        }
      }
    },

    components: {
      P400,
    },

    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  .page{padding-top: .3rem; padding-bottom: .3rem; }
  .px-container { width: 100%;}
  .px-waterfall { width: 50%;}
  .px-waterfall img.bg-img {border-radius: 8px; }
  .icon-tx {position:relative;width: 100%;height: auto; border-radius: .08rem .08rem 0 0;}
  .icon-tx img {float: left;width: 100%;height: auto;border-radius: .08rem .08rem 0 0;}
  .guide-tag{position: absolute;left: .15rem;top: .12rem;font: bold .24rem "Microsoft YaHei";color: #fff;text-shadow: 0 0 .04rem #2b7fda;}
  .px-waterfall:first-child{padding: 0 .16rem 0 .24rem}
  .px-waterfall:last-child{padding: 0 .24rem 0 .16rem}
  .px-waterfall li{ margin-bottom: .36rem;background: #fff;border-radius: .08rem;box-shadow: 0 0 0.25rem #f5f5f5;overflow: hidden;}
  .bottom-box{width: 100%;padding: .2rem;}
  .guide-name{font: .24rem/.4rem "Microsoft YaHei";color: #686868;}
  .guide-name span.name{max-width:55%;}
  .guide-name span.num{font: .2rem/.4rem "Microsoft YaHei";color: #666;}
  .guide-name span.num img{float: left;width: auto;height: .2rem;margin-top: .1rem;margin-right: .05rem;}
  .bag-name{margin-bottom:.12rem;font:bold .28rem/.36rem "Microsoft YaHei";color: #000;}

  .load-tip{margin-top: 0;}
</style>



// WEBPACK FOOTER //
// src/page/home/guide-list.vue